import $ from "jquery";
import "../../../vendor/legacy_rails_assets/jquery-timeago/jquery.timeago.js";

let applied = false;

// jquery-timeago ships English strings only; merge the js.plugins.timeago
// translations in once before an element is initialized. The locale files mark
// absent affixes with the literal string "NULL" (a convention from the legacy
// bundle), which must become null so the plugin skips them instead of
// rendering "NULL".
export default function localizeTimeago() {
  if (applied) return;

  // I18n.t is declared as returning a string, but a scope lookup yields the
  // nested translation object -- and the "[missing ...]" message string as long
  // as the translations are not on the page yet. The guard below skips that
  // case without latching, so a later call can still localize.
  const strings = I18n.t("js.plugins.timeago") as unknown as
    | Record<string, string>
    | string
    | undefined;
  if (!strings || typeof strings !== "object") return;
  applied = true;

  Object.assign(
    $.timeago.settings.strings,
    Object.fromEntries(
      Object.entries(strings).map(([key, value]) => [
        key,
        value === "NULL" ? null : value,
      ]),
    ),
  );
}
